/* Lumen Glow theme — small, dependency-free interactions. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header: scrolled state + mobile menu ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = header.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('MobileMenu');
    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        menu.hidden = open;
        header.classList.toggle('menu-open', !open);
      });
    }
  }

  /* ---------- Reveal on scroll ---------- */
  var revealTargets = document.querySelectorAll('.section-head, .card, .feature, .quote, .about__copy, .about__visual, .details__panel');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          el.classList.add('is-in');
          io.unobserve(el);
          // Drop the reveal classes once done so hover transforms work normally.
          setTimeout(function () { el.classList.remove('reveal', 'is-in'); }, 1400);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.setProperty('--reveal-delay', (i % 4) * 80 + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Colour showcase: swap image + tint on swatch click ---------- */
  document.querySelectorAll('[data-colour-picker]').forEach(function (root) {
    var nameEl = root.querySelector('[data-colour-name]');
    var cta = root.querySelector('[data-colour-cta]');
    var swatches = root.querySelectorAll('[data-colour-swatch]');
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.colourSwatch;
        swatches.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', String(on));
        });
        root.querySelectorAll('[data-colour-image]').forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.colourImage === id);
        });
        root.style.setProperty('--swatch', btn.dataset.colourHex);
        if (nameEl) nameEl.textContent = btn.dataset.colourLabel;
        if (cta && btn.dataset.colourLink) cta.href = btn.dataset.colourLink;
      });
    });
  });

  /* ---------- Reviews: Write a review toggle ---------- */
  document.querySelectorAll('[data-reviews]').forEach(function (root) {
    var form = root.querySelector('.review-form');
    var openBtn = root.querySelector('[data-write-review]');
    if (!form || !openBtn) return;
    var keepOpen = form.querySelector('[data-review-posted], .form-error');
    if (!keepOpen) form.classList.add('is-collapsed');
    else form.scrollIntoView({ block: 'center' });
    openBtn.addEventListener('click', function () {
      form.classList.remove('is-collapsed'); openBtn.setAttribute('aria-expanded', 'true');
      var first = form.querySelector('input:not([type=hidden])'); if (first) first.focus();
    });
    var cancel = form.querySelector('[data-cancel-review]');
    if (cancel) cancel.addEventListener('click', function () { form.classList.add('is-collapsed'); openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); });
  });

  /* ---------- Product hero ---------- */
  document.querySelectorAll('[data-product-hero]').forEach(initHero);

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function initHero(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var mapEl = root.querySelector('[data-colour-map]');
    var colourMap = {};
    try { colourMap = mapEl ? JSON.parse(mapEl.textContent) : {}; } catch (e) { colourMap = {}; }

    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var mainImg = root.querySelector('[data-main-image]');
    var errorEl = root.querySelector('[data-form-error]');
    var colourThumb = root.querySelector('[data-colour-thumb]');
    var colourFieldset = root.querySelector('.ph__colours');
    var colourIndex = colourFieldset ? parseInt(colourFieldset.dataset.optionIndex, 10) : -1;
    var current = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];

    function swapImage(src) {
      if (!mainImg || !src || mainImg.getAttribute('src') === src) return;
      mainImg.style.opacity = 0;
      setTimeout(function () { mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.style.opacity = 1; }, 150);
    }
    function setActiveThumb(btn) {
      root.querySelectorAll('[data-thumb]').forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
    }

    // Mini photos open the photo viewer (handled in footnest-extra.js)

    // Quantity
    var qty = root.querySelector('[data-qty]');
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10)); });
    });

    // Variant selection
    root.querySelectorAll('[data-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        var fs = input.closest('[data-option-index]');
        var label = fs && fs.querySelector('[data-option-value]');
        if (label) label.textContent = input.value;
        updateVariant(fs && parseInt(fs.dataset.optionIndex, 10) === colourIndex);
      });
    });

    function selectedOptions() {
      var sel = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('[data-option]:checked');
        sel[parseInt(fs.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      return sel;
    }

    function updateVariant(colourChanged) {
      var sel = selectedOptions();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
      if (colourChanged && colourIndex >= 0) {
        var entry = colourMap[sel[colourIndex]];
        var src = (variant && variant.featured_image && variant.featured_image.src) || (entry && entry.src);
        if (src) { swapImage(src); if (colourThumb) { colourThumb.dataset.src = src; var ti = colourThumb.querySelector('img'); if (ti) ti.src = src; setActiveThumb(colourThumb); } }
      }
      if (!variant) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      current = variant;
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (document.body.classList.contains('template-product')) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString());
      }
    }

    // Added-to-bag pop-up
    var added = root.querySelector('[data-added]'), lastFocus = null;
    function showAdded(itemCount) {
      if (!added) { showToast(); return; }
      var img = added.querySelector('[data-added-img]');
      if (img && mainImg) img.src = mainImg.src;
      var variantEl = added.querySelector('[data-added-variant]');
      if (variantEl) variantEl.textContent = current && current.title !== 'Default Title' ? current.title : '';
      var offer = added.querySelector('[data-added-offer]');
      if (offer) {
        var every = parseInt(offer.dataset.offerEvery, 10) || 0, rem = itemCount % every;
        if (!every) offer.hidden = true;
        else if (rem === 0) { offer.className = 'offer-progress offer-progress--done'; offer.textContent = 'Free pair unlocked! The offer is applied at checkout.'; }
        else { var need = every - rem; offer.className = 'offer-progress'; offer.textContent = 'Add ' + need + ' more and get one free.'; }
      }
      lastFocus = document.activeElement;
      added.hidden = false;
      var close = added.querySelector('.added__close'); if (close) close.focus();
    }
    function closeAdded() { added.hidden = true; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    if (added) {
      added.addEventListener('click', function (e) { if (e.target.closest('[data-close-added]')) closeAdded(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !added.hidden) closeAdded(); });
    }

    // AJAX add to cart (falls back to a normal form post if turned off)
    var ajaxEnabled = document.body.dataset.ajaxCart !== 'false';
    if (form && ajaxEnabled && window.fetch) {
      form.setAttribute('data-ajax-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        addBtn.classList.add('is-loading');
        var base = ((window.theme && window.theme.routes.root) || '/').replace(/\/?$/, '/');
        fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data.description || result.data.message || 'Could not add to bag');
            return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) { updateCartCount(cart.item_count); showAdded(cart.item_count); })
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }
  }

  function updateCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  var toastTimer;
  function showToast() {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 3200);
  }
})();
